<template>
  <div class="container" :class="{'container_qr': isQrOnlyMode}">
    <div class="container_box">
      <div class="container_header">
        <div class="container_header_title">Mã đặt hàng</div>
        <div class="container_header_content">
          <div class="container_header_left">
            <img class="container_header_left_img" :src="qrUrl" alt="">
          </div>
          <div class="container_header_right">
            <img class="container_header_right_img" src="@/assets/p_all.png" alt="">
            <div @click="downloadImage(qrUrl)" class="container_header_right_btn">Lưu mã QR</div>
          </div>
        </div>
      </div>
      <template v-if="!isQrOnlyMode">
        <div class="container_dotted"></div>
        <div class="container_main" :class="{'container_main_remark': remark}">
          <div class="container_desc">
            "Nếu sử dụng mã QR bất tiện, vui lòng sao chép thông tin tài khoản để chuyển tiền."
          </div>
          <div class="container_info">
            <div class="container_info_item">
              <div class="container_info_title">Tên ngân hàng:</div>
              <div class="container_info_box">
                <div class="container_info_value">{{ bankName }}</div>
              </div>
            </div>
            <div class="container_info_item">
              <div class="container_info_title">Tên tài khoản:</div>
              <div class="container_info_box">
                <div class="container_info_value">{{ vaName }}</div>
              </div>
            </div>
            <div class="container_info_item">
              <div class="container_info_title">Tài Khoản:</div>
              <div class="container_info_box">
                <div class="container_info_value">{{ accountNumber }}</div>
                <div @click="onCopy(accountNumber)" class="container_info_copy">sao chép</div>
              </div>
            </div>
            <div class="container_info_item" v-if="amount">
              <div class="container_info_title">Số tiền:</div>
              <div class="container_info_box">
                <div class="container_info_value">{{ formatNumber(amount) }}</div>
                <div @click="onCopy(amount)" class="container_info_copy">sao chép</div>
              </div>
            </div>
            <div class="container_info_item" v-if="remark">
              <div class="container_info_title">Ghi chú:</div>
              <div class="container_info_box">
                <div class="container_info_value">{{ remark }}</div>
                <div @click="onCopy(remark)" class="container_info_copy">sao chép</div>
              </div>
            </div>
          </div>
          <div class="container_tips">
            <div class="container_tips_label">Những điều cần lưu ý:</div>
            <div class="container_tips_value">
              Vui lòng kiểm tra số tài khoản và tên người nhận thanh toán.
              Hệ thống sẽ tự động nạp tiền cho bạn sau khi chuyển khoản thành công.
            </div>
          </div>
      </div>
      </template>
    </div>
</div>
</template>


<script>
import indexJs from "@/mixins/index";

export default {
  name: "Computer",
  mixins: [indexJs],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  min-height: 100vh;
  //height: 864px;
  background: url("~@/assets/p_bgi.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .container_box {
    width: 1540px;
    height: 76vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .container_header {
      padding-top: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      width: 278px;

      .container_header_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #743900;
      }

      .container_header_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 35px;
        margin-top: 10px;

        .container_header_left {
          width: 278px;
          height: 278px;
          background: url("~@/assets/p_qrbox.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .container_header_left_img {
            width: 228px;
            height: 228px;
          }
        }

        .container_header_right {
          width: 278px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 25px;

          .container_header_right_img {
            width: 278px;
            height: 38px;
          }

          .container_header_right_btn {
            cursor: pointer;
            margin-top: 40px;

            width: 230px;
            height: 60px;
            background: #914405;
            border-radius: 30px;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 23px;
            color: #FFFFFF;

            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .container_dotted {
      width: 1px;
      height: 76vh;
      margin: 0 60px;
      background: linear-gradient(
              to top,
              transparent 0%,
              transparent 50%,
              #875525 50%,
              #875525 100%
      );
      background-size: 1px 10px;
      background-repeat: repeat-y;
    }

    .container_main {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      height: 100%;
      width: 772px;
      padding: 20px 0;

      .container_desc {
        margin-top: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 19px;
        color: #743900;
      }

      .container_info {

        .container_info_item {
          margin-top: 20px;

          .container_info_title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #743900;
          }

          .container_info_box {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 30px;

            .container_info_value {
              flex: 1;
              overflow-wrap: break-word; /* 新属性，推荐使用 */
              word-break: break-all; /* 在任何字符之间换行 */
              padding: 10px 20px;
              box-sizing: border-box;

              display: flex;
              align-items: center;
              justify-content: flex-start;

              min-width: 612px;
              width: 100%;
              min-height: 56px;
              background: rgba(255, 255, 255, 0.5);
              border-radius: 28px;
              border: 1px solid #FFFFFF;

              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 22px;
              color: #FF8B00;
            }

            .container_info_copy {
              cursor: pointer;
              width: 108px;
              height: 56px;
              background: #914405;
              border-radius: 28px;
              margin-left: 20px;

              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 19px;
              color: #FFFFFF;

              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }

      .container_tips {
        //margin-top: 20px;

        .container_tips_label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 20px;
          color: #743900;
        }

        .container_tips_value {
          margin-top: 6px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #FF3D3D;
          line-height: 26px;
        }
      }

      &.container_main_remark {
        .container_desc {
          margin-top: 10px;
          font-size: 17px;
        }

        .container_info {
          .container_info_item {
            margin-top: 10px;

            .container_info_title {
              font-size: 18px;
            }

            .container_info_box {
              margin-top: 5px;

              .container_info_value {
                min-height: 46px;
                padding: 7px 20px;
                font-size: 19px;
              }

              .container_info_copy {
                height: 46px;
                font-size: 17px;
              }
            }
          }
        }

        .container_tips {
          .container_tips_label {
            font-size: 18px;
          }

          .container_tips_value {
            margin-top: 3px;
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
    }
  }

  &.qr-only-mode {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0e0e0e; /* Dark background to mimic image link */
    height: 100vh;
    width: 100vw;
    margin: 0;
    padding: 0;
  }
}

.container_qr {
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;

  .container_box {
    width: auto;
    height: auto;
    align-items: flex-start;
    flex-wrap: wrap;
  }
}

.qr-code-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .container_header_left_img {
    width: 100%;
    height: 100%;
    object-fit: contain; // Ensure square aspect ratio is maintained
  }
}
</style>
